export function AlertBanner({
  variant = "success", // "success" | "error" | "warning"
  children,
  onDismiss,
}) {
  const styles =
    variant === "success"
      ? "border-emerald-300 bg-emerald-50 text-emerald-900"
      : variant === "error"
      ? "border-rose-300 bg-rose-50 text-rose-900"
      : "border-amber-300 bg-amber-50 text-amber-900";

  return (
    <div className={`rounded-2xl border p-4 text-sm flex items-center justify-between ${styles}`}>
      <div className="pr-3">{children}</div>

      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="font-medium opacity-70 hover:opacity-100"
        >
          Dismiss
        </button>
      )}
    </div>
  );
}
